import { useMemo } from 'react';
import { INTERACT, INTERACTION_CLICK } from '../../constants/analytics';
import { track } from '../../redux/actions/analytics';
import { InteractTrackHandler } from '../../types/analytics';
import useLatest from '../../web-shared/hooks/use-latest';
import useAppDispatch from '../use-app-dispatch';
import useRouteInteractProps from './use-route-interact-props';

export function useInteractTrack() {
  const dispatch = useAppDispatch();
  const routeInteractProps = useLatest(useRouteInteractProps());

  const handleInteractTrack: InteractTrackHandler = propOverrides => {
    const { component = '', ...restOverrides } = propOverrides;
    const analyticsProps = {
      action: INTERACTION_CLICK,
      ...routeInteractProps.current,
      ...restOverrides,
      component,
    };
    dispatch(track(INTERACT, analyticsProps));
  };

  return useMemo(
    () => ({
      // generic reusable handler
      handleInteractTrack,
    }),
    [],
  );
}
